// extracted by mini-css-extract-plugin
export default {"textAreaContainer":"styles_textAreaContainer__DUdn-"};